/* TOMB CLOCK — cart drawer grouping.
   The "2 for $200" deal splits the same watch into several cart lines. The drawer shows each
   watch as one row (snippets/tc-cart-drawer-content.liquid, data-keys = every line key of that
   watch). For those grouped rows, + / − / Remove / typing a quantity set the TOTAL quantity of
   the watch: first line gets the new total, the other lines go to 0, and Shopify re-applies the
   deal. Single-line rows keep using the theme's normal handler in tc-global.js. */
(() => {
  if (window.__tcCartGroup) return;
  window.__tcCartGroup = true;

  const TC = (window.TC = window.TC || {});

  const updateUrl = () => {
    const r = TC.routes || {};
    if (r.cart_update_url) return `${r.cart_update_url}.js`;
    return `${(r.cart_url || '/cart').replace(/\/$/, '')}/update.js`;
  };

  const keysOf = (line) => [...new Set((line?.dataset.keys || '').split(',').map((k) => k.trim()).filter(Boolean))];

  async function setGroup(line, quantity) {
    if (!line || line.getAttribute('aria-busy') === 'true') return;
    const keys = keysOf(line);
    if (!keys.length) return;
    const updates = {};
    keys.forEach((k, i) => { updates[k] = i === 0 ? quantity : 0; });
    line.setAttribute('aria-busy', 'true');
    let failed = false;
    try {
      const res = await fetch(updateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status) throw new Error(json.description || json.message || (TC.strings && TC.strings.cart_error) || 'Error');
    } catch (error) {
      failed = true;
      if (TC.toast) TC.toast(error.message, 'error');
    } finally {
      line.removeAttribute('aria-busy');
      if (TC.refreshCart) await TC.refreshCart();
    }
    if (!failed && quantity === 0 && TC.toast) TC.toast((TC.strings && TC.strings.removed) || 'Removed');
  }

  const grouped = (el) => {
    const line = el?.closest?.('#TcCart [data-tc-line]');
    return line && keysOf(line).length > 1 ? line : null;
  };

  document.addEventListener('click', (event) => {
    const line = grouped(event.target);
    if (!line) return;
    const qtyBtn = event.target.closest('[data-tc-qty]');
    const remove = event.target.closest('[data-tc-remove]');
    if (!qtyBtn && !remove) return;
    event.preventDefault();
    event.stopPropagation();
    if (remove) {
      setGroup(line, 0);
      return;
    }
    const input = line.querySelector('[data-tc-qty-input]');
    const step = Number(input?.step) || 1;
    const current = Number(input?.value) || 0;
    const min = Number(input?.dataset.min) || 1;
    let next = qtyBtn.dataset.tcQty === 'plus' ? current + step : current - step;
    if (next > 0 && next < min) next = 0;
    if (input?.max && next > Number(input.max)) next = Number(input.max);
    setGroup(line, Math.max(0, next));
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-tc-qty-input]');
    const line = input && grouped(input);
    if (!line) return;
    event.stopPropagation();
    setGroup(line, Math.max(0, parseInt(input.value, 10) || 0));
  }, true);
})();
